import React, { FC } from 'react';
import { twMerge } from 'tailwind-merge';

import { EmptySearchList } from '../../../components/empty-search-list/index';
import {
  EmptyState,
  EmptyStateImageVariant,
  EmptyStateVariant,
} from '../../../components/empty-state/index';
import { PaginationController } from '../../../components/pagination-controller/index';
import { useLocale } from '../../../hooks/index';
import { StakeholderItem } from '../stakeholder-item';
import { StakeholderTerminatedTable } from '../stakeholder-terminated-table/index';
import { StakeholdersCardComponentProps } from '../stakeholders';

export type TerminatedCardProps = StakeholdersCardComponentProps;

export const TerminatedCard: FC<TerminatedCardProps> = ({
  currentPage,
  handlePageChange,
  totalPages,
  ...props
}) => {
  const { searchValue: search, data } = props;
  const { messagesLocale } = useLocale();
  return data?.length ? (
    <>
      <StakeholderTerminatedTable {...props} />
      <div
        className={twMerge(
          'flex h-fit w-full flex-wrap justify-center gap-4 px-4 pt-4 lg:hidden',
          search && data?.length === 0 && 'items-center',
        )}
      >
        {search && data?.length === 0 && <EmptySearchList className="my-20" />}

        {data?.map((stakeholderData) => (
          <StakeholderItem
            {...props}
            {...stakeholderData}
            key={stakeholderData.id}
            terminatedCard
          />
        ))}
      </div>
      <PaginationController
        className="shrink-0 max-lg:px-4 lg:mx-6"
        currentPage={currentPage}
        onClick={handlePageChange}
        totalPages={totalPages || 0}
      />
    </>
  ) : (
    <EmptyState
      colorScheme={EmptyStateVariant.ORANGE}
      description={messagesLocale['TERMINATED_STAKEHOLDERS_WILL_BE_HERE']}
      imageVariant={EmptyStateImageVariant.CLIPBOARD}
      text={messagesLocale['NO_TERMINATED_STAKEHOLDERS']}
    />
  );
};
